import axios from 'axios'

export const login = (info) => {
  return axios.post('/login', info)
}

export const changePassword = (data) => {
  return axios.post('account/change-password', data)
}

export const getPersonlInformation = () => {
  return axios.get('account')
}

export const updateStatusOnline = (data) => {
  return axios.put('account/update-status-online', data)
}



// WEBPACK FOOTER //
// ./src/api/accounts.js